import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43afc372&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=43afc372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43afc372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43afc372')) {
      api.createRecord('43afc372', component.options)
    } else {
      api.reload('43afc372', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=43afc372&scoped=true&", function () {
      api.rerender('43afc372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/screenfull/index.vue"
export default component.exports